export const WEBLATE_COMPONENT_NAME = 'vlc/vendasta-login-center-client';
